<template>
  <section class="container">
    <div class="detail">
      <div class="detail__content">
        <p v-html="noviceContent"></p>
      </div>
    </div>
  </section>
</template>

<script>
import { GetNovicesByMode } from '@/api/Novices';

export default {
  data() {
    return {
      type: [
        { modelId: 1, modelName: '', modelPath: 'policy' },
        { modelId: 2, modelName: '', modelPath: 'buyNote' },
        { modelId: 3, modelName: '', modelPath: 'about' },
        { modelId: 4, modelName: '', modelPath: 'class' },
        { modelId: 5, modelName: '', modelPath: 'buyProcess' },
        { modelId: 6, modelName: '', modelPath: 'contact' },
      ],
      noviceContent: '',
    };
  },
  created() {
    this.type[0].modelName = this.$t('guide.footer.policy');
    this.type[1].modelName = this.$t('guide.link.buyNote');
    this.type[2].modelName = this.$t('guide.footer.about');
    this.type[3].modelName = this.$t('guide.link.class');
    this.type[4].modelName = this.$t('guide.link.buyProcess');
    this.type[5].modelName = this.$t('guide.footer.contact');
    this.GetData();
  },
  watch: {
    $route() {
      this.GetData();
    },
  },
  methods: {
    GetData() {
      const { type } = this.$route.params;
      const modelId = this._.filter(this.type, ['modelPath', type]);
      if (this._.isEmpty(modelId)) this.$router.replace('/');
      window.document.title = `${this.$t('route.title.sitePrefix')}-${modelId[0].modelName}`;

      this.$emit('update:currentPage', {
        name: '',
        title: modelId[0].modelName,
        path: '',
      });
      GetNovicesByMode(modelId[0].modelId).then((response) => {
        if (response.data.statusCode === 0) {
          this.noviceContent = response.data.data.noviceContent;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
